/** Errors raised by the fastboot layer. All carry a stable `code` for i18n + logs. */

export type FastbootErrorCode =
  | "fail" // device answered FAIL
  | "protocol" // malformed response
  | "disconnected" // USB device went away (expected after unlock/lock/reboot)
  | "no_interface" // device has no fastboot interface (not in fastboot mode)
  | "too_large" // image cannot be split to fit max-download-size
  | "unsupported"; // WebUSB missing

export class FastbootError extends Error {
  readonly code: FastbootErrorCode;
  readonly command: string | undefined;
  readonly reason: string | undefined;

  constructor(code: FastbootErrorCode, message: string, opts: { command?: string; reason?: string } = {}) {
    super(message);
    this.name = "FastbootError";
    this.code = code;
    this.command = opts.command;
    this.reason = opts.reason;
  }
}

export function isDisconnect(err: unknown): boolean {
  if (err instanceof FastbootError) return err.code === "disconnected";
  if (err instanceof Error) {
    // Chromium raises DOMException(NetworkError|NotFoundError) when the device drops mid-transfer.
    return /NetworkError|NotFoundError|device was disconnected|no device selected/i.test(err.message + err.name);
  }
  return false;
}
